import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _569033e8 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _1cafbbfb = () => interopDefault(import('..\\pages\\business\\index.vue' /* webpackChunkName: "pages/business/index" */))
const _37eef7f5 = () => interopDefault(import('..\\pages\\cahandle\\index.vue' /* webpackChunkName: "pages/cahandle/index" */))
const _a524339a = () => interopDefault(import('..\\pages\\download\\index.vue' /* webpackChunkName: "pages/download/index" */))
const _341d233d = () => interopDefault(import('..\\pages\\guide\\index.vue' /* webpackChunkName: "pages/guide/index" */))
const _aa374ea0 = () => interopDefault(import('..\\pages\\login\\index.vue' /* webpackChunkName: "pages/login/index" */))
const _7ef46788 = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _779e51e2 = () => interopDefault(import('..\\pages\\outside-cjwt\\index.vue' /* webpackChunkName: "pages/outside-cjwt/index" */))
const _5ea59d90 = () => interopDefault(import('..\\pages\\register\\index.vue' /* webpackChunkName: "pages/register/index" */))
const _119ad2f8 = () => interopDefault(import('..\\pages\\business\\detail.vue' /* webpackChunkName: "pages/business/detail" */))
const _75011e76 = () => interopDefault(import('..\\pages\\business\\detail-sd.vue' /* webpackChunkName: "pages/business/detail-sd" */))
const _49e8dc2a = () => interopDefault(import('..\\pages\\business\\index copy.vue' /* webpackChunkName: "pages/business/index copy" */))
const _62fa5186 = () => interopDefault(import('..\\pages\\login\\index-zfcg.vue' /* webpackChunkName: "pages/login/index-zfcg" */))
const _1028cdea = () => interopDefault(import('..\\pages\\news\\detail.vue' /* webpackChunkName: "pages/news/detail" */))
const _0a54848c = () => interopDefault(import('..\\pages\\business\\components\\file-download.vue' /* webpackChunkName: "pages/business/components/file-download" */))
const _1070c594 = () => interopDefault(import('..\\pages\\business\\components\\link-paper.vue' /* webpackChunkName: "pages/business/components/link-paper" */))
const _0d8ba9aa = () => interopDefault(import('..\\pages\\business\\components\\search-bar.vue' /* webpackChunkName: "pages/business/components/search-bar" */))
const _6f746afa = () => interopDefault(import('..\\pages\\business\\components\\search-bar copy.vue' /* webpackChunkName: "pages/business/components/search-bar copy" */))
const _2af4a9a2 = () => interopDefault(import('..\\pages\\business\\components\\table-hxrgs.vue' /* webpackChunkName: "pages/business/components/table-hxrgs" */))
const _e70689ea = () => interopDefault(import('..\\pages\\register\\components\\btn-yzm.vue' /* webpackChunkName: "pages/register/components/btn-yzm" */))
const _4cc0eb8a = () => interopDefault(import('..\\pages\\register\\components\\captcha.vue' /* webpackChunkName: "pages/register/components/captcha" */))
const _6de24879 = () => interopDefault(import('..\\pages\\register\\components\\input-yzm.vue' /* webpackChunkName: "pages/register/components/input-yzm" */))
const _fe8df130 = () => interopDefault(import('..\\pages\\register\\components\\tos.vue' /* webpackChunkName: "pages/register/components/tos" */))
const _ce3adf0a = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _2f1cf1d6 = () => interopDefault(import('..\\pages\\index\\sections\\banner.vue' /* webpackChunkName: "pages/index/sections/banner" */))
const _fe5e652e = () => interopDefault(import('..\\pages\\index\\sections\\business.vue' /* webpackChunkName: "pages/index/sections/business" */))
const _1398e5f8 = () => interopDefault(import('..\\pages\\index\\sections\\enters.vue' /* webpackChunkName: "pages/index/sections/enters" */))
const _aa3861de = () => interopDefault(import('..\\pages\\index\\sections\\footlink.vue' /* webpackChunkName: "pages/index/sections/footlink" */))
const _825f51da = () => interopDefault(import('..\\pages\\index\\sections\\logins.vue' /* webpackChunkName: "pages/index/sections/logins" */))
const _a27ff108 = () => interopDefault(import('..\\pages\\index\\sections\\news.vue' /* webpackChunkName: "pages/index/sections/news" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _569033e8,
    alias: "/about/index.html",
    name: "about"
  }, {
    path: "/business",
    component: _1cafbbfb,
    alias: "/business/index.html",
    name: "business"
  }, {
    path: "/cahandle",
    component: _37eef7f5,
    alias: "/cahandle/index.html",
    name: "cahandle"
  }, {
    path: "/download",
    component: _a524339a,
    alias: "/download/index.html",
    name: "download"
  }, {
    path: "/guide",
    component: _341d233d,
    alias: "/guide/index.html",
    name: "guide"
  }, {
    path: "/login",
    component: _aa374ea0,
    alias: "/login/index.html",
    name: "login"
  }, {
    path: "/news",
    component: _7ef46788,
    alias: "/news/index.html",
    name: "news"
  }, {
    path: "/outside-cjwt",
    component: _779e51e2,
    alias: "/outside-cjwt/index.html",
    name: "outside-cjwt"
  }, {
    path: "/register",
    component: _5ea59d90,
    alias: "/register/index.html",
    name: "register"
  }, {
    path: "/business/detail",
    component: _119ad2f8,
    alias: "/business/detail/index.html",
    name: "business-detail"
  }, {
    path: "/business/detail-sd",
    component: _75011e76,
    alias: "/business/detail-sd/index.html",
    name: "business-detail-sd"
  }, {
    path: "/business/index%20copy",
    component: _49e8dc2a,
    alias: "/business/index%20copy/index.html",
    name: "business-index copy"
  }, {
    path: "/login/index-zfcg",
    component: _62fa5186,
    alias: "/login/index-zfcg/index.html",
    name: "login-index-zfcg"
  }, {
    path: "/news/detail",
    component: _1028cdea,
    alias: "/news/detail/index.html",
    name: "news-detail"
  }, {
    path: "/business/components/file-download",
    component: _0a54848c,
    alias: "/business/components/file-download/index.html",
    name: "business-components-file-download"
  }, {
    path: "/business/components/link-paper",
    component: _1070c594,
    alias: "/business/components/link-paper/index.html",
    name: "business-components-link-paper"
  }, {
    path: "/business/components/search-bar",
    component: _0d8ba9aa,
    alias: "/business/components/search-bar/index.html",
    name: "business-components-search-bar"
  }, {
    path: "/business/components/search-bar%20copy",
    component: _6f746afa,
    alias: "/business/components/search-bar%20copy/index.html",
    name: "business-components-search-bar copy"
  }, {
    path: "/business/components/table-hxrgs",
    component: _2af4a9a2,
    alias: "/business/components/table-hxrgs/index.html",
    name: "business-components-table-hxrgs"
  }, {
    path: "/register/components/btn-yzm",
    component: _e70689ea,
    alias: "/register/components/btn-yzm/index.html",
    name: "register-components-btn-yzm"
  }, {
    path: "/register/components/captcha",
    component: _4cc0eb8a,
    alias: "/register/components/captcha/index.html",
    name: "register-components-captcha"
  }, {
    path: "/register/components/input-yzm",
    component: _6de24879,
    alias: "/register/components/input-yzm/index.html",
    name: "register-components-input-yzm"
  }, {
    path: "/register/components/tos",
    component: _fe8df130,
    alias: "/register/components/tos/index.html",
    name: "register-components-tos"
  }, {
    path: "/",
    component: _ce3adf0a,
    alias: "/index.html",
    name: "index",
    children: [{
      path: "sections/banner",
      component: _2f1cf1d6,
      name: "index-sections-banner"
    }, {
      path: "sections/business",
      component: _fe5e652e,
      name: "index-sections-business"
    }, {
      path: "sections/enters",
      component: _1398e5f8,
      name: "index-sections-enters"
    }, {
      path: "sections/footlink",
      component: _aa3861de,
      name: "index-sections-footlink"
    }, {
      path: "sections/logins",
      component: _825f51da,
      name: "index-sections-logins"
    }, {
      path: "sections/news",
      component: _a27ff108,
      name: "index-sections-news"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
